import axios from 'axios';
import AppSettings from "../../../core/AppSettings";


const cartCardOfferEspot = "/wcs/resources/store/" + AppSettings.storeId + "/espot/Rewards_Card_Promo?noCache=true";

export const getCardOfferEspot = () => {
    return axios.get(cartCardOfferEspot).then((response) => { return response; }, (error) => { return error; });
};
